<template>
  <div
    class="split-block"
    :class="{ 'dashboard-node--highlight': highlighted }"
  >
    <div class="split-block__head">
      <div class="split-block__source">
        <b>{{ title }}</b>
        <div
          v-if="subtitle || status"
          class="split-block__source-meta"
        >
          <span v-if="subtitle">{{ subtitle }}</span>
          <BaseStatusPill
            v-if="status"
            :label="status.label"
            :variant="status.variant"
          />
        </div>
      </div>
      <div
        v-if="rule"
        class="split-block__rule"
      >
        {{ rule }}
      </div>
    </div>

    <BaseDashboardTable
      :columns="columns"
      :rows="destinations"
      :item-key="itemKey"
      :group-by="groupBy"
      :group-subtotals="groupSubtotals"
      :hide-default-footer="false"
      :server-items-length="serverItemsLength"
      :options="options"
      @detail="$emit('row-detail', $event)"
      @action="$emit('action', $event)"
      @update:options="$emit('update:options', { instance, options: $event })"
    />

    <div
      v-if="rounding"
      class="split-block__rounding"
    >
      <span>{{ rounding.note }}</span>
      <span>{{ rounding.amount }}</span>
    </div>
  </div>
</template>

<script>
import BaseDashboardTable from './BaseDashboardTable.vue'
import BaseStatusPill from './BaseStatusPill.vue'
import DashboardHighlightOnRender from '../../mixins/DashboardHighlightOnRender'

export default {
  name: 'BaseSplitBlock',
  mixins: [DashboardHighlightOnRender],
  components: { BaseDashboardTable, BaseStatusPill },
  props: {
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      required: false,
      default: ''
    },
    status: {
      type: Object,
      required: false,
      default: null
    },
    rule: {
      type: String,
      required: false,
      default: ''
    },
    columns: {
      type: Array,
      required: true
    },
    destinations: {
      type: Array,
      required: true
    },
    groupBy: {
      type: String,
      required: false,
      default: ''
    },
    groupSubtotals: {
      type: Object,
      required: false,
      default: () => ({})
    },
    itemKey: {
      type: String,
      required: false,
      default: undefined
    },
    rounding: {
      type: Object,
      required: false,
      default: null
    },
    instance: {
      type: String,
      required: false,
      default: ''
    },
    serverItemsLength: {
      type: Number,
      required: false,
      default: -1
    },
    options: {
      type: Object,
      required: false,
      default: () => ({})
    }
  }
}
</script>

<style lang="scss">
.split-block {
  &__head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
    margin-bottom: 16px;
  }

  &__source {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  &__source-meta {
    display: flex;
    align-items: center;
    gap: 8px;
    color: var(--ds-color-black-055);
    font-size: 0.875rem;
  }

  &__rule {
    color: var(--ds-color-black-055);
    font-size: 0.875rem;
  }

  &__rounding {
    display: flex;
    justify-content: space-between;
    margin-top: 8px;
    padding: 8px 12px;
    font-size: 0.8rem;
    color: var(--ds-color-black-055);
  }
}
</style>
